var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.436,
    height: 32,
    viewBox: "0 0 28.436 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M27.2,7.08,15.449.293a2.731,2.731,0,0,0-2.463,0L1.231,7.08A2.732,2.732,0,0,0,0,9.212V22.786a2.7,2.7,0,0,0,1.231,2.133l11.755,6.787a2.731,2.731,0,0,0,2.463,0L27.2,24.919a2.644,2.644,0,0,0,1.231-2.133V9.212A2.791,2.791,0,0,0,27.2,7.08Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.342,
    y1: 0.303,
    x2: 0.826,
    y2: 0.908,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b009b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#390086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.279,
    y1: 0.356,
    x2: 0.544,
    y2: 0.89,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#340084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.29,
    y1: 0.168,
    x2: 0.561,
    y2: 0.597,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a47ede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9866d3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C_Sharp_logo",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M222.588,124.487H239.3V141.58H222.588Z",
    transform: "translate(-208.676 -116.707)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M2.587,221.078-18.926,208.63H-29.911v20.608h32.5Z",
    transform: "translate(28.042 -195.591)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-29.911,11.712,2.587-7.093v-7.42h-32.5Z",
    transform: "translate(28.042 13.606)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M75.827,114.054c-.056-9.256,12.341-13.342,17.687-4.742l-4.1,2.374a4.74,4.74,0,1,0,0,4.737l4.1,2.374C88.8,126.975,76.065,124.032,75.827,114.054Zm15.636-2.688h.781l-.534,5.156h-.8Zm1.674,0h.781l-.534,5.156h-.8Zm-2.548,1.224h3.906v.755H90.588Zm-.219,1.838h3.906v.754H90.369Z",
    transform: "translate(-71.088 -98.054)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.96fabb7500959d1922633c0da39d8455.svg";
export { ForwardRef as ReactComponent };